import { Injectable } from '@angular/core';
import {catchError, map} from 'rxjs/operators';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable,throwError } from 'rxjs';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class CallService {

  httpOptions : any;

  public HOST: string = environment.backendUrl;

  constructor(private http: HttpClient) {
    // Http Headers
    this.httpOptions = {
            
    }
  }

  get(url:string,params: HttpParams = new HttpParams()):Observable<any>{
    this.httpOptions.params = params;
    return this.http.get(url, this.httpOptions)
    .pipe(
      catchError(this.handleError)
    );
  }

  post(object: any, url:string): Observable<any> {
    return this.http.post(url, object, this.httpOptions)
    .pipe(
        catchError(this.handleError)
    );
  }

  public extractData(res: any) {
		return res.result;
	}

  public handleError (error: HttpErrorResponse | any) {
    console.log("ERROR")
    console.log(error);
    if (error instanceof Error) {
      // A client-side or network error occurred. Handle it accordingly.
      console.log('An error occurred: ', error.message ? error.message : error.toString());
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
            if(error.error != undefined){
                console.log(`Backend returned code: ${error.status} - ${error.statusText}, body was: ${error.message}`);
                return throwError(error.error.message);
            }else{
                return throwError(error);
            }
            
    }
    console.log('Raw error:', error);
    return throwError(error);
  }

}
